<template>
<div class="award-con">
    <div class="have-award" v-if="user.is_win == 1">
        <div class="top-award">
            <div class="award-tips" @click="reward">奖品说明</div>
            <div class="back" @click="backButton"></div>
        </div>
        <div class="info-con">
            <div class="headimg"><img :src="user.head_img_url" alt=""></div>
            <div class="user-name">{{user.nickname}}</div>
        </div>
        <div class="awards">
            <div class="title">安康！您获得<span class="award-name">{{user.prize}}</span></div>
            <div class="title">请在2020年6月30日前领取奖品喔～</div>
            <div class="title">领奖ID：<span style="color: red">{{user.prize_id}}</span></div>
            <div class="award-img"><img :src="awardImgUrl" alt=""></div>
            <div class="get-award-con">
                <div class="qrcode"><img src="../../assets/H5img/award/qrcode.png" alt=""></div>
                <div class="award-right">
                    <div>截图保存本页</div>
                    <div style="margin-top: 0.24rem">扫码进入公众号<br>回复<span style="color: #e46c36" v-if="user.prize_number < 5">“端午”</span><span style="color: #e46c36" v-if="user.prize_number == 5">“端午”</span>兑换礼品</div>
                </div>
            </div>
            <div class="bottom-btn">
                <div class="to-list" @click="toList"></div>
                <div class="play-again" @click="playAgain"></div>
            </div>
        </div>
    </div>
    <div class="no-award-timein" v-if="user.is_win == 0">
        <div class="no-back" @click="backButton"></div>
        <div class="no-award-con">
            <div class="my-headimg"><img :src="user.head_img_url" alt=""></div>
            <div class="activity-time">活动时间：2020.05.31至2020.06.06</div>
        </div>
        <div class="no-again" @click="playAgain"></div>
        <div class="no-list" @click="toList"></div>
    </div>
    <div class="bottom-bg"></div>

    <!-- 弹窗蒙版 -->
    <div class="masking" v-show="showModal || showAwardTips ||showGameOverModal"></div>
    <div class="share-hand show" v-show="showModal"></div>
    <!-- 次数用完弹窗 -->
    <div class="game-modal show" style="top:39%"  v-show="showModal">
        <div class="model-top">
            <div class="modal-close" @click="closeModal"></div>
        </div>
        <div class="model-main">
            <div>当前您的游戏次数已用完，
                立即邀请好友助力获得游戏
                机会继续划龙舟吧！</div>
            <div class="to-ranklist" @click="toRankList"></div>
        </div>
        <div class="model-bottom"></div>
    </div>

      <!-- 奖品说明弹窗 -->
    <div class="game-modal show" style="top:25%" v-show="showAwardTips">
        <div class="model-top">
            <div class="modal-close" @click="closeRuleModal"></div>
        </div>
        <div class="model-main" style="padding: 0.7rem 0.3rem 0.9rem 0.3rem; color:#937533">
            <div class="left-line"></div>
            <div>奖品说明</div>
            <div class="right-line"></div>
            <div class="rule-tips">
                1、1-10名：公众号后台回复“安康”兑换礼品；<br>
                11-100名：公众号后台回复“端午”兑换礼品；
            </div>
            <div class="rule-tips">
                2、领取有效期截止2020年6月30日；<br>
            </div>
            <div class="rule-tips">
               3、奖品均为小罐茶官方正品。<br>
            </div>
        </div>
        <div class="model-bottom"></div>
    </div>
     <!-- 活动结束弹窗 -->
    <div class="game-modal show" v-show="showGameOverModal">
        <div class="model-top">
            <div class="modal-close" @click="closeGameOverModal"></div>
        </div>
        <div class="model-main" style="padding: 0.9rem 0.3rem">
            <div>当前活动已结束</div>
            <div class="gameover-time">（活动时间：2020.05.31至2020.06.06）</div>
            <div class="to-ranklist" @click="toRankList"></div>
        </div>
        <div class="model-bottom"></div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            gameOver:'',
            awardImgUrl: "",
            user: '',
            showModal: false,
            showAwardTips: false,  //奖品说明弹窗
            showGameOverModal: false, //活动结束弹窗
        }
    },
    methods: {
        reward() {
            this.showAwardTips = true
        },
        //关闭奖品说明弹窗
        closeRuleModal() {
            if (this.showAwardTips) {
                this.showAwardTips = false
            } else {
                this.showAwardTips = true
            }
        },
         //关闭游戏结束弹窗
        closeGameOverModal() {
            if (this.showGameOverModal) {
                this.showGameOverModal = false
            } else {
                this.showGameOverModal = true
            }
        },
        //跳转排行榜
        toRankList() {
            this.$router.replace({
                path: '/Mrank',
            })
        },
        backButton() {
            this.$router.replace({
                path: '/Mrank'
            })
        },
        playAgain() {
            if(this.gameOver == 1) {
                this.showGameOverModal = true
            }else {
                if(this.user.game_num > 0) {
                // document.getElementById("myAudio").pause();
                // document.getElementById("myAudio2").play();
                this.$router.replace({
                    path: '/Mgame'
                })
                }else {
                    this.showModal = true
                } 
            }
        },
        toList() {
            this.$router.push({
                path: '/Mlist'
            })
        },
        getAward() {
            let openId = localStorage.getItem('openId')
            this.$axios.post('/h5/api/createUser', {
                openId: openId,
            }, {}).then(res => {
                let user = res.data.data.user
                this.user = user
                console.log(user)
                if(user.is_win == 1) {
                    let prize_number = user.prize_number
                    switch (prize_number) {
                        case 1: 
                            // this.awardImgUrl = "url(" + require("../../assets/H5img/award/goods-1.png") + ")"
                            this.awardImgUrl = require("../../assets/H5img/award/goods-1.png")
                            break;
                        case 2: 
                            // this.awardImgUrl = "url(" + require("../../assets/H5img/award/goods-2.png") + ")"
                            this.awardImgUrl = require("../../assets/H5img/award/goods-2.png")
                            break;
                        case 3: 
                            // this.awardImgUrl = "url(" + require("../../assets/H5img/award/goods-3.png") + ")"
                            this.awardImgUrl = require("../../assets/H5img/award/goods-3.png")
                            break;
                        case 4: 
                            // this.awardImgUrl = "url(" + require("../../assets/H5img/award/goods-5.png") + ")"
                            this.awardImgUrl = require("../../assets/H5img/award/goods-5.png")
                            break;
                        case 5: 
                            // this.awardImgUrl = "url(" + require("../../assets/H5img/award/goods-4.png") + ")"
                            this.awardImgUrl = require("../../assets/H5img/award/goods-4.png")
                            break;
                    }
                }
                
            })
        },
        //关闭弹窗
        closeModal() {
            if (this.showModal) {
                this.showModal = false
            } else {
                this.showModal = true
            }
        },
          //设置分享
        setWxShare() {
            let openId = localStorage.getItem('openId')
            let avatar = localStorage.getItem('avatar')
            let username = localStorage.getItem('username')
            // let shareUrl = `https://smalltea.xiaoxxx.cn/#/Msupport?myopenid=${openId}&myavatar=${avatar}&myname=${username}`
            let shareUrl = `https://smalltea.xiaoxxx.cn/#/Msupport?myopenid=${openId}`
            console.log(shareUrl)
            // shareUrl = "http://test.smalltea.xiaoxxx.cn/#/Msupport?myopenid=123&myavatar=888"
            // alert(shareUrl)
            // 微信分享
            window.wx.ready(() => {
                // 分享好友
                window.wx.updateAppMessageShareData({
                    title: "乘风破浪·粽享端午", // 分享标题
                    desc: "快来助力好友瓜分小罐茶3万大奖吧！", // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        console.log(url);
                        // 设置成功
                        // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数', '1', '1']);
                    }
                });
                // 分享朋友圈
                window.wx.updateTimelineShareData({
                    title: "乘风破浪·粽享端午", // 分享标题
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        // 设置成功
                        window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享朋友圈次数', '分享朋友圈次数', '1', '1']);
                    }
                });
                // 1.2.0 老接口
                wx.onMenuShareAppMessage({
                    title: "乘风破浪·粽享端午", // 分享标题
                    desc: "快来助力好友瓜分小罐茶3万大奖吧！", // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        // 设置成功
                        // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数', '1', '1']);
                    }
                });
                wx.onMenuShareTimeline({
                    title: "乘风破浪·粽享端午", // 分享标题
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        // 设置成功
                        window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享朋友圈次数', '分享朋友圈次数', '1', '1']);
                    }
                });
            });
        }

    },
    created() {
        this.gameOver = localStorage.getItem('game-over')
        this.getAward()
        this.setWxShare()
    }
}
</script>

<style scoped>
.award-con {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 13rem;
    background-color: #d3f5ea;
    overflow: hidden;
    user-select: none;
    text-align: center;
}

.top-award {
    text-align: right;
}

.bottom-bg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 7.5rem;
    height: 4.31rem;
    background: url('../../assets/H5img/award/bottom-bg.png') no-repeat;
    background-size: cover;
    background-position: center;
}

.award-tips {
    display: inline-block;
    width: 1.5rem;
    color: #602923;
    text-decoration: underline;
    font-size: 0.34rem;
    font-weight: bold;
    margin-top: 0.4rem;
    margin-right: 0.5rem;
    text-align: right;
    z-index: 1;
}

.back {
    position: absolute;
    top: 0.5rem;
    left: 0.54rem;
    width: 0.25rem;
    height: 0.43rem;
    background: url('../../assets/H5img/award/back.png') no-repeat;
    background-size: cover;
    background-position: center;
    z-index: 2;
}
.no-back {
    position: absolute;
    top: 0.5rem;
    left: 0.54rem;
    width: 0.25rem;
    height: 0.43rem;
    background: url('../../assets/H5img/award/back.png') no-repeat;
    background-size: cover;
    background-position: center;
    z-index: 20;
}
.headimg {
    position: relative;
    width: 1.7rem;
    height: 1.7rem;
    background: #fff;
    border-radius: 50%;
    margin: 0 auto;
}

.headimg img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1.63rem;
    height: 1.63rem;
    border-radius: 50%;
}

.user-name {
    width: 7rem;
    margin: 0 auto;
    font-size: 0.36rem;
    font-weight: bold;
    margin-top: 0.2rem;
}

.awards {
    margin-top: 0.4rem;
}

.title {
    font-size: 0.3rem;
    color: #254740;
    font-weight: bold;
}

.award-name {
    font-size: 0.4rem;
}

.award-img {
    width: 5.8rem;
    height: 2.51rem;
    margin: 0 auto;
    margin-top: 0.7rem;
}
.award-img img{
    /* width: 100%; */
    height: 100%;
}

.get-award-con {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 5.96rem;
    height: 1.95rem;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 0.12rem;
    margin-top: 0.5rem;
    z-index: 2;
}

.qrcode {
    width: 1.64rem;
    height: 1.64rem;
    /* background: url('../../assets/H5img/award/qrcode.png') no-repeat;
    background-size: cover;
    background-position: center; */
    margin-left: 0.75rem;
}

.qrcode img {
    width: 100%;
    height: 100%;
}

.award-right {
    margin-right: 0.8rem;
    font-size: 0.24rem;
    color: #31423e;
}

.bottom-btn {
    position: relative;
    display: flex;
    width: 6rem;
    margin: 0 auto;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.54rem;
    z-index: 3;
}

.to-list {
    width: 2.64rem;
    height: 0.81rem;
    background: url('../../assets/H5img/award/list-btn.png') no-repeat;
    background-size: cover;
    background-position: center;
}

.play-again {
    width: 2.64rem;
    height: 0.81rem;
    margin: 0 0.2rem;
    background: url('../../assets/H5img/rank/play-again.png') no-repeat;
    background-size: cover;
    background-position: center;
}
/* 没有奖品 */
.no-award-con {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 6.7rem;
    height: 9.25rem;
    background: url('../../assets/H5img/award/no-award.png') no-repeat;
    background-size: cover;
    background-position: center;
    z-index: 2;
}
.my-headimg {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 2rem;
    width: 1.54rem;
    height: 1.54rem;
    background: #f0ba90;
    border: 0.05rem solid #fff;
    border-radius: 50%;
}
.my-headimg img{
    width: 100%;
    border-radius: 50%;
}
.activity-time {
    position: absolute;
    top: 7.6rem;
    left: 50%;
    width: 100%;
    text-align: center;
    transform: translateX(-50%);
    color: #254740;
    font-size: 0.24rem;
}
.no-again {
    position: absolute;
    top: 9.6rem;
    left: 50%;
    transform: translateX(-50%);
    width: 5.1rem;
    height: 0.94rem;
    background: url('../../assets/H5img/award/again.png') no-repeat;
    background-size: cover;
    background-position: center;
    z-index: 2;
}
.no-list {
    position: absolute;
    top: 11rem;
    left: 50%;
    transform: translateX(-50%);
    width: 5.1rem;
    height: 0.94rem;
    background: url('../../assets/H5img/award/list.png') no-repeat;
    background-size: cover;
    background-position: center;
    z-index: 2;
}
.left-line {
    position: absolute;
    top: 0.95rem;
    left: 0.4rem;
    width: 1.33rem;
    height: 1px;
    background-color: #d6bd87;
}

.right-line {
    position: absolute;
    top: 0.95rem;
    right: 0.4rem;
    width: 1.33rem;
    height: 1px;
    background-color: #d6bd87;
}

.rule-tips {
    text-align: left;
    color: #937533;
    padding-left: 18px;
    text-indent: -18px;
    font-size: 0.24rem;
    font-weight: normal;
    margin-top: 0.1rem;
}
.share-hand {
  position: absolute;
  top: 0.5rem;
  right: 0.3rem;
  width: 2.73rem;
  height: 2.15rem;
  background: url("../../assets/H5img/share-hand.png") no-repeat;
  background-size: cover;
  background-position: center;
  z-index: 11;
}
</style>
